import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Emprendedores y dueños de negocio que se sienten abrumados por su lista de pendientes.', 'Freelancers que luchan por sentarse a trabajar sin supervisión externa.', 'Personas que "trabajan mucho" pero sienten que no avanzan en lo que realmente importa.', 'Tipos prácticos que odian la teoría y quieren pasos accionables inmediatos.'];
  const isNotFor = ['Personas que buscan un curso profundo sobre psicología clínica.', 'Quienes no están dispuestos a dedicar 10 minutos a seguir instrucciones simples.', 'Aquellos que prefieren seguir quejándose de su falta de tiempo en lugar de probar un método nuevo.'];
  return <section className="py-24 bg-brand-card relative border-y border-white/5" data-id="element-10">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-12">
          {/* Who it is for */}
          <FadeIn direction="right" data-id="element-13">
            <div className="bg-brand-dark rounded-3xl p-8 md:p-10 border border-green-500/20 h-full relative overflow-hidden" data-id="element-14">
              <div className="absolute top-0 right-0 w-32 h-32 bg-green-500/5 blur-[50px] rounded-full" data-id="element-15" />
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-16">
                <div className="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center" data-id="element-17">
                  <Check className="text-green-500 w-6 h-6" data-id="element-18" />
                </div>
                Para quién ES esto:
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-19">
                {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-20">
                    <Check className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-21" />
                    <span className="text-gray-300 text-lg leading-relaxed" data-id="element-22">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Who it is NOT for */}
          <FadeIn direction="left" delay={0.2} data-id="element-23">
            <div className="bg-brand-dark rounded-3xl p-8 md:p-10 border border-red-500/20 h-full relative overflow-hidden" data-id="element-24">
              <div className="absolute top-0 right-0 w-32 h-32 bg-red-500/5 blur-[50px] rounded-full" data-id="element-25" />
              <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3" data-id="element-26">
                <div className="w-10 h-10 rounded-full bg-red-500/20 flex items-center justify-center" data-id="element-27">
                  <X className="text-red-500 w-6 h-6" data-id="element-28" />
                </div>
                Para quién NO es esto:
              </h3>
              <ul className="space-y-6 relative z-10" data-id="element-29">
                {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-30">
                    <X className="w-6 h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-31" />
                    <span className="text-gray-400 text-lg leading-relaxed" data-id="element-32">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}